import Model, { encoders, ID } from 'src/models/model'
import Movie from 'src/models/movie/Movie'
import User from 'src/models/user/User'

export default class UserMovie extends Model {
  static name = 'UserMovie'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      user: {
        type: User,
        encode: encoders.hasOne,
        reference: true
      },
      userId: {
        type: ID,
        required: true
      },
      movie: {
        type: Movie,
        encode: encoders.hasOne,
        reference: true
      },
      movieId: {
        type: ID,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      rating: {
        type: String,
        required: false
      }
    }
  }
}
